export const initialHeader = { value: '', index: 1 };
export const initialPhone = { value: '', index: 2 };

export const initialImgKey = 'dataURL';
